import React, { useContext } from "react";
import { useTranslation } from 'react-i18next';
import { AppContext } from "../AppContextProvider";
import close from "../assets/media/icons/cross-thin.svg";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
} from "mdb-react-ui-kit";

export default function DeleteModal(props) {
  const { t } = useTranslation();
  const context = useContext(AppContext);

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="delete-modal">
        <MDBModalDialog scrollable centered size="md">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                <span className="title-text">{t('modals.delete.title')}</span>
              </MDBModalTitle>
              <MDBBtn className="button subtle large" type="button" onClick={props.handleClose}>
                <img src={close} alt={t('common.buttons.close')} />
              </MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="text-value-2">{t('modals.delete.confirmDelete')}</div>
            </MDBModalBody>
            <MDBModalFooter>
              <div className="modal-button">
                <button type="button" className="button neutral medium" onClick={props.handleClose}>
                  <span className="text p15">{t('common.buttons.cancel')}</span>
                </button>
                <button type="button" className="button brand medium" onClick={props.onDeleteFeedback}>
                  <span className="text p15">{t('common.buttons.delete')}</span>
                </button>
              </div>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
